<header-bar title=""></header-bar>
<div class="page-content">
    <div class="card card-style mt-3" style="background-color: white!important;">
        <div class="content">
            <h1>Zugriff nicht möglich</h1>
            <p>
                Der Zugriff auf Dein Account ist zur Zeit nicht möglich.
            </p>
            <p>
                Bitte logge Dich in Deinem Account unter https://app.youtine.de ein.
            </p>
        </div>
    </div>
</div>
